/* Progressive mobile layout: Shopify's existing product handlers own price,
 * fit, availability, cart requests and accelerated checkout. */
(() => {
  function initialize() {
    if (document.documentElement.dataset.dlMobileReady) return;
    document.documentElement.dataset.dlMobileReady = 'true';
    const mobile = matchMedia('(max-width: 749px)');
    const header = document.querySelector('.pc-header');
    const shell = header?.closest('.shopify-section') || header;
    const benefits = header?.querySelector('.pc-benefits');
    const benefitAnchor = document.createComment('original benefits position');
    benefits?.before(benefitAnchor);
    const root = document.querySelector('[data-pc-product],[data-diana-matching-set]');
    const brandLinks = '<a class="dl-discovery-editorial" href="/pages/our-story" target="_blank" rel="noopener noreferrer">Our Story</a><a class="dl-discovery-editorial" href="/pages/crystal-atlas" target="_blank" rel="noopener noreferrer">Crystal Atlas</a>';
    let homeNav = null, productNav = null;
    if (shell && document.querySelector('[data-dl-mobile-home]')) {
      homeNav = document.createElement('nav');
      homeNav.className = 'dl-discovery-nav dl-home-discovery';
      homeNav.hidden = true;
      homeNav.setAttribute('aria-label', 'Delivery, returns and brand navigation');
      const policyLinks = benefits?.querySelectorAll('a');
      for (const [index, label, fallback] of [[0, 'Shipping', '/policies/shipping-policy'], [1, '30-day returns', '/policies/refund-policy']]) {
        const link = document.createElement('a');
        link.href = policyLinks?.[index]?.getAttribute('href') || fallback;
        link.textContent = label; link.target = '_blank'; link.rel = 'noopener noreferrer';
        homeNav.append(link);
      }
      homeNav.insertAdjacentHTML('beforeend', brandLinks);
      shell.after(homeNav);
    }
    let updateProduct = () => {};
    function updateHeader() {
      shell?.classList.toggle('dl-header-shell', mobile.matches);
      document.body.classList.toggle('dl-mobile-product-page', mobile.matches && Boolean(root));
      document.body.classList.toggle('dl-discovery-active', mobile.matches && Boolean(homeNav || productNav));
      if (homeNav) homeNav.hidden = !mobile.matches;
      if (benefits) {
        benefits.classList.toggle('dl-header-benefits', mobile.matches);
        if (mobile.matches) shell.after(benefits);
        else benefitAnchor.after(benefits);
      }
      document.documentElement.style.setProperty('--dl-header-height', `${mobile.matches ? shell?.getBoundingClientRect().height || 94 : 0}px`);
      updateProduct();
    }

    if (root) {
      const form = root.querySelector('[data-pc-product-form],[data-ms-form]');
      const add = form?.querySelector('[name="add"]');
      const id = form?.querySelector('[name="id"]');
      const price = root.querySelector('[data-pc-price],[data-ms-price]');
      const title = root.querySelector('.pc-product-title');
      const sizes = root.querySelector('.pc-sizes');
      const details = root.querySelector('.pc-disclosure');
      const fit = root.querySelector('[data-pc-fit],[data-ms-fit]');
      const status = root.querySelector('[data-pc-status],[data-ms-status]');
      const choices = [...root.querySelectorAll('[data-pc-variant],[data-ms-size]')];
      if (form && add && id && sizes && details && title && price) {
        const initial = {id:id.value, label:add.textContent, disabled:add.disabled, fit:fit?.innerHTML,
          aria:choices.map(c=>({current:c.getAttribute('aria-current'),pressed:c.getAttribute('aria-pressed')}))};
        let confirmed = new URL(location.href).searchParams.get('variant') === id.value;
        let entered = false;
        const quick = form.querySelector('[data-pc-quick-checkout]');
        const nav = document.createElement('nav');
        nav.className = 'dl-product-jump dl-discovery-nav'; nav.hidden = true;
        nav.setAttribute('aria-label', 'Product and brand navigation');
        nav.innerHTML = '<button type="button" data-dl-jump="purchase">Shop piece</button><button type="button" data-dl-jump="details">Details</button>' + brandLinks;
        productNav = nav;
        const bar = document.createElement('div');
        bar.className = 'dl-product-buy-bar'; bar.hidden = true; bar.dataset.dlBuyBar = '';
        bar.innerHTML = '<div><strong data-dl-bar-price></strong><small></small></div><button type="button" data-dl-buy></button>';
        const buy = bar.querySelector('button');
        const barPrice = bar.querySelector('[data-dl-bar-price]');
        bar.querySelector('small').textContent = root.hasAttribute('data-diana-matching-set') ? 'Pet + owner set' : 'Pet collar only';
        root.after(nav,bar);
        function jump(target) {
          target.tabIndex = -1;
          target.focus({preventScroll:true});
          target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        }
        nav.querySelectorAll('[data-dl-jump]').forEach(button => button.addEventListener('click', () => jump(button.dataset.dlJump === 'purchase' ? sizes : details)));
        function chooseFirst() { jump(sizes); choices[0]?.focus({preventScroll:true}); }
        function guard(event) {
          if (!mobile.matches || confirmed) return;
          event.preventDefault(); event.stopImmediatePropagation();
          if (status) status.textContent = 'Choose your size by the listed neck measurement.';
          chooseFirst();
        }
        add.addEventListener('click', guard, true);
        form.addEventListener('submit', guard, true);
        buy.addEventListener('click', () => {
          if (!confirmed) chooseFirst();
          else if (!add.disabled) form.requestSubmit(add);
        });
        function sync() {
          const enabled = mobile.matches;
          root.classList.toggle('dl-product-enhanced',enabled);
          root.classList.toggle('dl-size-unselected',enabled && !confirmed);
          if (!enabled) { nav.hidden=true; bar.hidden=true; return; }
          if (barPrice.textContent !== price.textContent) barPrice.textContent = price.textContent;
          const label = confirmed ? add.textContent : 'Choose size';
          if (buy.textContent !== label) buy.textContent = label;
          buy.disabled = confirmed && add.disabled;
          const headerHeight = shell?.getBoundingClientRect().height || 94;
          nav.hidden = false;
          const top = headerHeight + 44;
          const rect = add.getBoundingClientRect();
          bar.hidden = rect.height > 0 && rect.top >= top && rect.bottom <= innerHeight;
          const onDetails = details.getBoundingClientRect().top <= top + 18;
          nav.querySelectorAll('button').forEach(button => {
            if ((button.dataset.dlJump === 'details') === onDetails) button.setAttribute('aria-current','location');
            else button.removeAttribute('aria-current');
          });
        }
        root.addEventListener('click', event => {
          const choice = event.target.closest('[data-pc-variant],[data-ms-size]');
          if (!choice || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !choices.includes(choice)) return;
          confirmed = Boolean(id.value);
          root.classList.remove('dl-size-unselected');
          sync();
        });
        // Add each option's own recorded neck range; never borrow another SKU's fit.
        choices.forEach(choice => {
          let text = '';
          if (choice.dataset.pcVariant) {
            const template = [...root.querySelectorAll('template[data-pc-fit-for]')].find(t=>t.dataset.pcFitFor===choice.dataset.pcVariant);
            text = template?.content.querySelector('strong')?.firstChild?.textContent || '';
          } else {
            const row = [...root.querySelectorAll('[data-ms-size-row]')].find(r=>r.dataset.msSizeRow===choice.dataset.msSize);
            text = row?.cells[1]?.textContent || '';
          }
          const range = text.match(/\d+(?:\.\d+)?\s*[–-]\s*\d+(?:\.\d+)?\s*cm/);
          if (range) { const small=document.createElement('small'); small.className='dl-option-fit'; small.textContent=range[0]; choice.append(small); }
        });
        updateProduct = () => {
          if (mobile.matches && !entered) {
            entered = true;
            if (!confirmed) {
              id.value = '';
              choices.forEach(choice=>{choice.removeAttribute('aria-current');if(choice.hasAttribute('aria-pressed'))choice.setAttribute('aria-pressed','false');});
              add.disabled=false;add.textContent='Choose size';
              if (quick) quick.hidden=true;
              if (fit) {fit.replaceChildren();const prompt=document.createElement('span');prompt.textContent='Choose by your pet’s neck measurement.';fit.append(prompt);}
            }
          } else if (!mobile.matches && entered) {
            entered=false;
            if (!confirmed) {
              id.value=initial.id;add.textContent=initial.label;add.disabled=initial.disabled;
              choices.forEach((choice,i)=>{for(const key of ['current','pressed']){const value=initial.aria[i][key];if(value===null)choice.removeAttribute('aria-'+key);else choice.setAttribute('aria-'+key,value);}});
              if (fit) fit.innerHTML=initial.fit;
              // Let the native handler reconcile current quantity and availability.
              form.querySelector('[name="quantity"]')?.dispatchEvent(new Event('input',{bubbles:true}));
            }
          }
          sync();
        };
        new MutationObserver(sync).observe(form,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-busy']});
        let scheduled=false;
        const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});};
        document.addEventListener('scroll',schedule,{passive:true});
        window.addEventListener('scrollend',sync);
        window.addEventListener('pageshow',sync);
      }
    }
    mobile.addEventListener('change',updateHeader);
    window.addEventListener('resize',updateHeader);
    updateHeader();
  }
  document.addEventListener('DOMContentLoaded',initialize,{once:true});
  if(document.readyState==='complete')initialize();
})();
